import React from "react";
import Link from "@/Layouts/Link";

export default function TextAgreement(props) {
    const {className = '', textButton = '', location = ''} = props;
    const parts = [];

    if (textButton) {
        parts.push(`Нажимая кнопку «${textButton}», вы соглашаетесь с условиями`);
    } else {
        parts.push(`Нажимая кнопку, вы соглашаетесь с условиями`);
    }

    return (
        <div className={`textAgreement${className && ' ' + className}`}>
            {parts.join(' ')}{' '}
            <Link href={`/politika-konfidencialnosti`} className={`form__personal`} target={`_blank`}>
                обработки персональных данных
            </Link>
            {location === 'basket' && (
                <>
                    <span> и </span>
                    <Link href={`/rule/dogovor-publichnoj-oferty`}
                       className={`form__personal`}
                       target={`_blank`}>
                        договора оферты
                    </Link>
                </>
            )}
        </div>
    );
}
